import BarChart from "./component/BarChart";
import BarChart2 from "./component/BarChart2";
import LineChart from "./component/LineChart";
import Member from "./component/Member";
import Styles from "./css/UserStatistics.module.scss";

const UserStatistics = () => {
  return (
    <>
      <main className={`${Styles.userStatistics}`}>
        <div className={`${Styles.container}`}>
          <div className={`${Styles.userStatisticsContainer}`}>
            <BarChart />
          </div>
          <div className={`${Styles.google_map}`}>
            <Member />
          </div>
        </div>
        <div className={`${Styles.container2}`}>
          <div className={`${Styles.userStatisticsContainer}`}>
            <BarChart2 />
          </div>
          <div className={`${Styles.userStatisticsContainer}`}>
            <LineChart />
          </div>
        </div>
      </main>
    </>
  );
};

export default UserStatistics;
